import { Injectable } from '@angular/core';
import { Observable ,  Subject , BehaviorSubject} from 'rxjs';

@Injectable()
export class dataService {
    private subject = new BehaviorSubject<any>(null);

    // don't use "any", type your data instead!
    private partApiData = new BehaviorSubject<any>(null);
    public partApiData$ = this.partApiData.asObservable();

    private packageID = new BehaviorSubject<any>(null);
    public packageID$ = this.packageID.asObservable();

    setpartAPIData(data) { 
        this.partApiData.next(data);
    }

    getPartAPIdata(): Observable<any> {
        return this.partApiData.asObservable();
    }

    setPackageID(Id){
        this.packageID.next(Id);
    }   

    sendFormData(formData: any) {       
        this.subject.next({ formDataVal: formData });
    }

    getFormData(): Observable<any> {
        return this.subject.asObservable();
    }

    // sendSupplyFormData(formData: any) {
    //     this.subject.next({ formDataVal: formData });
    // }

    // getSupplyFormData(): Observable<any> {
    //     return this.subject.asObservable();
    // }
    
}